import { render, staticRenderFns } from "./mainListTag.vue?vue&type=template&id=826b50f4&"
import script from "./mainListTag.vue?vue&type=script&lang=js&"
export * from "./mainListTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports